import {Component, OnInit} from '@angular/core';
import {DialogRef} from '@progress/kendo-angular-dialog';
import {MarketConfigChange} from '../../shared/models/markets-config.model';

interface ChangeSummaryLine {
    label: string;
    count: number;
}

// [singular, plural] display phrasing per action - keys match market_config_audit's action
// set exactly (the underlying action string sent to the API). block_* is shared by both
// modes (no dedicated service_* audit values - see base-market-editor.ts), so the wording
// has to come from `mode` instead: "rule" on the ranges-mode screen, "service" per-service.
// market_* labels are the same either way.
const RANGES_ACTION_LABELS: {[action: string]: [string, string]} = {
    block_add: ['rule added', 'rules added'],
    block_edit: ['rule edited', 'rules edited'],
    block_delete: ['rule deleted', 'rules deleted'],
    market_create: ['market created', 'markets created'],
    market_rename: ['market renamed', 'markets renamed'],
    market_delete: ['market deleted', 'markets deleted'],
    external_edit: ['market imported via CSV', 'markets imported via CSV'],
    priority_reorder: ['market priority order changed', 'markets\' priority order changed']
};

const SERVICE_ACTION_LABELS: {[action: string]: [string, string]} = {
    ...RANGES_ACTION_LABELS,
    block_add: ['service added', 'services added'],
    block_edit: ['service moved', 'services moved'],
    block_delete: ['service removed', 'services removed']
};

@Component({
    selector: 'app-save-changes-dialog',
    templateUrl: './save-changes-dialog.component.html',
    styleUrls: ['./save-changes-dialog.component.scss']
})
export class SaveChangesDialogComponent implements OnInit {
    // Set by the caller right after dialogService.open(), before the dialog is shown.
    changes: MarketConfigChange[] = [];
    email = '';
    mode: 'ranges' | 'services' = 'ranges';

    reason = '';
    summaryLines: ChangeSummaryLine[] = [];

    constructor(private dialogRef: DialogRef) {
    }

    ngOnInit(): void {
        const labels = this.mode === 'services' ? SERVICE_ACTION_LABELS : RANGES_ACTION_LABELS;
        const counts = new Map<string, number>();
        this.changes.forEach(change => counts.set(change.action, (counts.get(change.action) ?? 0) + 1));
        this.summaryLines = Array.from(counts.entries()).map(([action, count]) => {
            const [singular, plural] = labels[action] ?? [action, action];
            return {label: count === 1 ? singular : plural, count};
        });
    }

    public onCancel(): void {
        this.dialogRef.close({confirmed: false});
    }

    public onSave(): void {
        this.dialogRef.close({confirmed: true, reason: this.reason.trim() || null});
    }
}
